<template>
  <vx-card>
    <div id="mt-5">
      <vs-tabs position="top">
        <vs-tab label="Tipos de Visado" icon-pack="feather" icon="icon-flag">
          <div class="tab-text mt-5">
            <VisaTypesIndex></VisaTypesIndex>
          </div>
        </vs-tab>
        <vs-tab label="Tipos de Documentos" icon-pack="feather" icon="icon-archive">
          <div class="tab-text mt-5">
            <DocumentTypesIndex></DocumentTypesIndex>
          </div>
        </vs-tab>
        <vs-tab label="Plantilla Pasos para Visado" icon-pack="feather" icon="icon-clipboard">
          <div class="tab-text mt-5">
            <VisaStepTypesIndex></VisaStepTypesIndex>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import VisaTypesIndex from './VisaTypesIndex.vue'
import DocumentTypesIndex from './DocumentTypesIndex.vue'
import VisaStepTypesIndex from './VisaStepTypesIndex.vue'

export default {
  components: {
    VisaTypesIndex,
    DocumentTypesIndex,
    VisaStepTypesIndex
  }
}
</script>